<template>
	<div class="paragraph" :id="advanced.cssId" :class="['el-'+details.id, advanced.cssClasses, responsiveClasses]"
	     :style="style">
		<v-style>
			{{ fontCss }}
		</v-style>
		<div class="paragraph-inner" v-html="details.content || '<p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Unde, maxime</p>'"></div>
	</div>
</template>

<script>
import {
	borderProps,
	boxShadow,
	fontProps,
	letterSpacing,
	lineHeight,
	textShadow,
	getPadding, responsiveFontStyles,
} from "@/modules/page-editor/src/utils/props";

export default {
    name: 'EmailParagraph',
	props: ["details"],
	computed: {
		basic() {
			return this.details.attributes.basic;
		},
		advanced() {
			return this.details.attributes.advanced;
        },
        responsive() {
            return this.details.responsive
        },
        responsiveClasses() {
            let c = '';
            if (!this.responsive) return '';
            if (!this.responsive.desktop) c = 'no-desktop';
            if (!this.responsive.mobile) c += ' no-mobile';
            if (!this.responsive.tablets) c += ' no-tablet';
            return c;
        },
		fontCss() {
			return responsiveFontStyles(this.basic.font, this.details.id);
		},
        style() {
            return {
            	...fontProps(this.basic.font, 'desktop', true, true),
	            ...borderProps(this.basic.border),
	            lineHeight: lineHeight(this.basic.lineHeight),
	            letterSpacing: letterSpacing(this.basic.letterSpacing),
              margin: getPadding(this.basic.margin),
              padding: getPadding(this.advanced.padding),
              backgroundColor: this.basic.backgroundColor || null,
              boxShadow: boxShadow(this.basic.shadows),
	            textShadow: textShadow(this.advanced.textShadows),
            };

            return obj
        },
    }
};
</script>
